export default __webpack_public_path__ + "static/m-blog3-c110e145dd510f4596077898d32b14d8.jpg";